module.exports = __webpack_public_path__ + "static/media/hospital-software-doctor-patient-consultation.a05f144b.webp";